import Vue from "vue";
import App from "./App.vue";
// import './index.css';
import VueLeoCommon from "@greateasternlife/leo-design-token";
import Vuelidate from "vuelidate";
import { components } from "./register-components";
import router from "./router/index";
import appProp from "./utils/properties.js";
import "./assets/tailwind.css";
// import "@greateasternlife/leo-animate-css/dist/leo-animate-css";
import store from "./store/index";
import { CommonClass } from "@/mixins";
// axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";

Vue.config.productionTip = false;
// Vue.config.devtools = true
Vue.use(Vuelidate);
Vue.use(VueLeoCommon);
Vue.use(appProp);
// register all components

Object.entries(components).forEach(([name, component]) => {
  Vue.component(name, component);
});

if (!window.dataLayer) {
  window.dataLayer = [];
}

if (process.env.VUE_APP_ENABLE_ANALYTICS == "true") {
  window.dataLayerPush = function (event) {
    const eventO = event["event"] || "trackEvent";
    // let appId = "unknown";
    // try {
    //   appId = JSON.parse(sessionStorage.getItem("appId")) || "unknown";
    // } catch {
    //   console.log("appId error");
    // }
    const category = event["eventDetails.category"] || JSON.parse(sessionStorage.getItem("eventDetails.category"));
    const s_journeyType = event["journeyType"] || sessionStorage.getItem("journeyType");
    // const journeyType = appId + " " + s_journeyType;
    const journeyType = s_journeyType ?? 'n/a';
    const label = event["eventDetails.label"] ?? 'n/a';
    const appId = event["appId"] ?? 'n/a';
    const userGroup = CommonClass.methods.$__checkIsDesktopChannel() ? 'MO' : 'FO';
    const dataLayerObject = {
      event: eventO,
      event_category: category,
      event_label: label,
      journeyType,
      appID: appId,
      'user_group': userGroup || 'n/a',
      ...(event?.page_referrer && { page_referrer: event?.page_referrer ?? 'n/a' }),
      ...(event?.page_location && { page_location: event?.page_location ?? 'n/a' }),
      ...(event?.page_title && { page_title: event?.page_title ?? 'n/a' }),
      ...(event?.content_group && { content_group: event?.content_group ?? 'n/a' })
    };
    
    window.dataLayer.push(dataLayerObject);
  };
}

new Vue({
  store,
  router,
  render: (h) => h(App),
}).$mount("#app");
